





let client = 'pc';

export function setClient(c :string){
    client = c
}


export const Tracking = {
    PV: (uid: string, client_ip: string) => {
         //@ts-ignore
        beacon.onDirectUserAction("rqd_js_pv", {
            ua: client,
            dz_uid: uid,
            view_ip: client_ip,
            isLogin: uid ? '已登录' : '未登录',
        });
    },
    UA: (uid: string, client_ip: string) => {
         //@ts-ignore
        beacon.onDirectUserAction("uv_test_for_h5", {
            ua: client,
            dz_uid: uid,
            view_ip: client_ip,
            isLogin: uid ? '已登录' : '未登录',
        });
    },
    UP: (click: any, uid: string = "", argument: any = {}) => {
         //@ts-ignore
        beacon.onDirectUserAction(click, {
            client: client,
            uid:uid,
            isLogin: uid ? '已登录' : '未登录',
            ...argument
        });
    }
}

export const Matomo = (uid :string) => {
     //@ts-ignore
    var _paq = (window._paq = window._paq || []);
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(["appendToTrackingUrl", "bots=1"]);
    _paq.push(["setUserId", uid]);
    _paq.push(["trackPageView"]);
    _paq.push(["enableLinkTracking"]);
    (function () {
        var u = "//bbsdb.colg.cn/";
        _paq.push(["setTrackerUrl", u + "matomo.php"]);
        _paq.push(["setSiteId", "1"]);
        var d = document,
            g = d.createElement("script"),
            s = d.getElementsByTagName("script")[0];
        g.type = "text/javascript";
        g.async = true;
        g.src = u + "matomo.js";
        s.parentNode?.insertBefore(g, s);
    })();
}